import React from "react";
import "./textField.scss";
import Search from "../../../images/search.svg";
import Question from "../../../images/question.svg";

const TextField = ({
  type,
  required,
  placeholder,
  className,
  value,
  SearchIcon,
  label,
  QuestionIcon,
  onChange,
  readOnly,
}) => {
  return (
    <div
      className={`textFields pR ${className} ${
        SearchIcon || QuestionIcon ? "icon" : ""
      }`}
    >
      {label && <label className="dB">{label}</label>}
      <input
        className="w100"
        type={type}
        required={required}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
      />
      {QuestionIcon && <img className="pA" src={Question} width={20} />}
      {SearchIcon && <img className="pA" src={Search} width={20} />}
    </div>
  );
};

export default TextField;
